export default __webpack_public_path__ + "static/media/writingSheetD.5890b329.jpg";